import { render, staticRenderFns } from "./soundboard-tab.vue?vue&type=template&id=76426462&"
import script from "./soundboard-tab.vue?vue&type=script&lang=js&"
export * from "./soundboard-tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports